module.exports = __webpack_public_path__ + "media/25.072f8925.wav";